<template>
  <div>
    <ts-loading-banner :loading="loading">
      <div class="ts-flex ts-item-end">
        <ts-input
          v-tooltip="$t('productProfile.writeOffSearch')"
          v-model="search"
          :placeholder="$t('productProfile.writeOffSearch')"
          style="width: 100%;"
          class="inline-block"
        />
      </div>
      <div class="overflow-auto ts-mt-3">
        <ts-table :columns="columns" :records="resources" :loading="loading">
          <template v-slot="{ record }">
            <td>{{ record.branch_name_en }}</td>
            <td>{{ record.write_off_number }}</td>
            <td>{{ record.stock_in_number }}</td>
            <td>{{ record.remarks }}</td>
            <td class="ts-text-center">
              <span class="badge badge-success" v-if="record.is_confirm"
                >Yes</span
              >
              <span class="badge badge-danger" v-else>No</span>
            </td>
            <td>{{ record.name }}</td>
            <td>{{ record.confirmed_date }}</td>
          </template>
        </ts-table>
      </div>
      <div class="d-flex justify-content-between align-items-center p-15">
        <ts-total-list v-model="pagination" />
        <ts-pagination
          v-model="pagination"
          @navigate="fetchData"
        ></ts-pagination>
      </div>
    </ts-loading-banner>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { debounce } from 'lodash'
export default {
  name: 'transferReceived',
  data() {
    return {
      loading: false
    }
  },
  computed: {
    ...mapState('product/productDetailWriteOff', ['resources', 'pagination']),
    search: {
      get() {
        return this.$store.state.product.productDetailWriteOff.search
      },
      set(newValue) {
        this.$store.commit('product/productDetailWriteOff/SET_SEARCH', newValue)
        this.$store.commit('product/productDetailWriteOff/RESET_CURRENT_PAGE')
      }
    },
    columns() {
      return [
        { name: this.$t('productProfile.branchName'), style: 'width: 7%' },
        { name: this.$t('productProfile.writeOff#') },
        { name: this.$t('productProfile.referencePurchaseInvoice') },
        { name: this.$t('productProfile.remark') },
        { name: this.$t('productProfile.isConfirm'), style: 'text-align:center' },
        { name: this.$t('productProfile.confirmedBy') },
        { name: this.$t('productProfile.confirmDate') },
      ]
    }
  },
  methods: {
    ...mapActions('product/productDetailWriteOff', ['fetch']),
    fetchData() {
      this.loading = true
      this.fetch(this.$route.params.id)
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    }
  },
  watch: {
    search: debounce(function() {
      this.fetchData()
    }, 500)
  }
}
</script>
